import React from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

function Settings() {
    const navigate = useNavigate();
    const {  logout } = useAuth();
         const handleLogout = async () => {
    logout();
    navigate("/login");
  };
    return (
        <div>
            <Header />
            <Leftmenu />
            <Rightmenu />
            <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
                <div className="middle-sidebar-bottom">
                    <div className="middle-sidebar-left">
                        <div className="middle-wrap">
                            <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                                <div className="card-body p-lg-5 p-4 w-100 border-0">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <h4 className="mb-4 font-xxl fw-700 mont-font mb-lg-5 mb-4 font-md-xs">Settings</h4>
                                            <div className="nav-caption fw-600 font-xssss text-grey-500 mb-2">Genaral</div>
                                            <ul className="list-inline mb-4">
                                                <li className="list-inline-item d-block border-bottom me-0">
                                                    <Link to={`/update-profile/basic`} className="pt-2 pb-2 d-flex align-items-center">
                                                        <i className="btn-round-md bg-primary-gradiant text-white feather-home font-md me-3" />
                                                        <h4 className="fw-600 font-xsss mb-0 mt-0">Basic Information</h4>
                                                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3" />
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item d-block border-bottom me-0">
                                                    <Link to={`/update-profile/personal`} className="pt-2 pb-2 d-flex align-items-center">
                                                        <i className="btn-round-md bg-primary-gradiant text-white feather-user font-md me-3" />
                                                        <h4 className="fw-600 font-xsss mb-0 mt-0">Personal Information</h4>
                                                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3" />
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item d-block border-bottom me-0">
                                                    <Link to={`/update-profile/academic`} className="pt-2 pb-2 d-flex align-items-center">
                                                        <i className="btn-round-md bg-primary-gradiant text-white feather-book font-md me-3" />
                                                        <h4 className="fw-600 font-xsss mb-0 mt-0">Academic Information</h4>
                                                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3" />
                                                    </Link>
                                                </li>
                                                <li className="list-inline-item d-block border-bottom me-0">
                                                    <Link to={`/update-profile/professional`} className="pt-2 pb-2 d-flex align-items-center">
                                                        <i className="btn-round-md bg-primary-gradiant text-white feather-briefcase font-md me-3" />
                                                        <h4 className="fw-600 font-xsss mb-0 mt-0">Professional Information</h4>
                                                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3" />
                                                    </Link>
                                                </li>
                                               
                                            </ul>
                                        
                                            <div className="nav-caption fw-600 font-xsss text-grey-500 mb-2">Other</div>
                                            <ul className="list-inline">
                                               
                                               
                                                <li className="list-inline-item d-block me-0">
                                                    <a href="#" className="pt-2 pb-2 d-flex align-items-center" onClick={handleLogout}>
                                                        <i className="btn-round-md bg-red-gradiant text-white feather-lock font-md me-3" />
                                                        <h4 className="fw-600 font-xsss mb-0 mt-0">Logout</h4>
                                                        <i className="ti-angle-right font-xsss text-grey-500 ms-auto mt-3" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Settings